// can't use Next.js router, it thinks that passed url is located inside the app it serves,
// but right now it is a part of the legacy CLJS app. Replace the `location.replace` with
// the `router.replace` when the main page is served with the Next.js.
export const navigateToOldFrontEnd = (url: string) => window.location.replace(url)
